module.exports = __webpack_public_path__ + "static/img/ARAD3_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD3_1.png
// module id = +/Nr
// module chunks = 0